/*
DRIVER DIGITAL CUSTOM FOOTER SCRIPTS

Vite includes all minified JS within the <head> in theme.liquid,
so we use this file when it's necessary to include scripts in the
footer, before the closing </body> tag.
*/

// Load all external links in a new tab
document.addEventListener('DOMContentLoaded', function () {
  const links = document.getElementsByTagName('a');
  const currentHost = window.location.hostname;

  // Process anchor tags
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    const href = link.getAttribute('href');

    // Skip if there's no href attribute
    if (!href) continue;

    // Skip if it's a relative URL or starts with '/'
    if (href.startsWith('/') || !href.includes('://')) continue;

    try {
      const url = new URL(href);

      // Skip if it's the same domain or a Shopify URL
      if (url.hostname === currentHost ||
          url.hostname.includes('myshopify.com') ||
          url.hostname === 'cdn.shopify.com') {
        continue;
      }

      // Open external links in a new tab
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    } catch (e) {
      // If URL parsing fails, it's likely an internal link
      continue;
    }
  }
});
